<template>
  <div class="sidebar">
    <SidebarSettings
      :active="active"
      :user="user"
      @usersettings="openUserSettings"
      @teamsettings="openTeamSettings"
      @logout="logout"
    />
    <div class="d-contents spacey-36">
      <Menu />
      <SidebarProjectsList :projects="projects" />
      <SidebarProjectsList
        id="sidebar_incoming_projects"
        :projects="incomingProjects"
        is-incoming-projects
      />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import SidebarSettings from '@/components/sidebar/Settings';
  import SidebarProjectsList from '@/components/sidebar/ProjectsList';
  import UserSettingsModal from '@/containers/top-menu/header/profile-settings/UserModal';
  import TeamSettingsModal from '@/containers/top-menu/header/profile-settings/team/TeamModal';
  import Menu from '@/components/sidebar/Menu';

  export default {
    name: 'Sidebar',
    components: {
      SidebarProjectsList,
      SidebarSettings,
      Menu,
    },
    props: {
      open: Boolean,
      projects: {
        type: Array,
        default: () => [],
      },
      incomingProjects: {
        type: Array,
        default: () => [],
      },
    },
    computed: mapState({
      user: (state) => state.auth.user,
      active: (state) => state.auth.user?.membership,
    }),
    methods: {
      ...mapActions({
        openSidebar: 'global/openSidebar',
        logout: 'auth/logout',
        openModal: 'modal/openModal',
      }),
      openUserSettings() {
        this.openModal({ component: UserSettingsModal });
      },
      openTeamSettings() {
        this.openModal({
          component: TeamSettingsModal,
          context: {
            attributes: {
              class: 'my-team-modal team-modal',
            },
          },
        });
      },
    },
  };
</script>
